/**
 * How long a deleted image stays recoverable before its file is destroyed.
 *
 * Linear: MYD-463.
 *
 * **This number must match `RETENTION_DAYS` in
 * `backend/utilities/imageRetention.js`**, which is what the purge job
 * actually enforces. Telling a user thirty days while the job destroys at
 * seven would be worse than saying nothing, because they would rely on it.
 *
 * It is duplicated rather than imported: this is app code compiled by CRA, and
 * reaching into `backend/` from the bundle would drag a server module into the
 * browser build. `imageRetention.parity.test.ts` imports both and fails if they
 * ever disagree, following `capabilities.parity.test.ts`.
 */
export const IMAGE_RETENTION_DAYS = 30

/**
 * What a user is told when they delete an image.
 *
 * The previous wording was "This action cannot be undone... permanently
 * remove". That was true when nothing ever destroyed the stored file, in the
 * sense that the row never came back, and it is the wrong shape now: the
 * picture is recoverable for a month and only then destroyed for good.
 *
 * Both halves matter. "It goes away now" is what they asked for; "and it is
 * really gone in a month" is the part that was never true before and is the
 * reason this work exists.
 */
export const imageDeleteNotice = (days: number = IMAGE_RETENTION_DAYS): string =>
	`It will disappear from your library straight away. The stored file is kept for ${days} days ` +
	`in case this was a mistake, then permanently destroyed.`

export default IMAGE_RETENTION_DAYS
